import { render, staticRenderFns } from "./loyalty-select.vue?vue&type=template&id=99163a8e"
import script from "./loyalty-select.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports